import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
};

const profileSlice = createSlice({
  name: "profiledata",
  initialState,
  reducers: {
    storeUserProfileData(state, action) {
      state.data = action.payload;
    },
  },
});

export const { storeUserProfileData } = profileSlice.actions;

export default profileSlice.reducer;
